import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.pages`

export default defineMessages({
  settingsPageTitle: {
    id: `${scope}.settingsPageTitle`,
    defaultMessage: 'Settings',
  },
  punchOutSuppliersPageTitle: {
    id: `${scope}.punchOutSuppliersPageTitle`,
    defaultMessage: 'PunchOut suppliers',
  },
  punchOutGroupConnectionLogsPageTitle: {
    id: `${scope}.punchOutGroupConnectionLogsPageTitle`,
    defaultMessage: 'Connection logs',
  },
})
